var _createForOfIteratorHelper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
/**
 * Class represents SVG document
 */
var OrangeSVG = /*#__PURE__*/function () {
  "use strict";

  /**
   * Creates SVG object
   *
   * @param {number} width Width
   * @param {number} height Height
   * @param {number} x1 X coordinate of top left corner
   * @param {number} y1 Y coordinate of top left corner
   */
  function OrangeSVG() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var x1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var y1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    _classCallCheck(this, OrangeSVG);
    this.w = width;
    this.h = height;
    this.x1 = x1;
    this.y1 = y1;
    this._children = [];
  }

  /**
   * Width
   *
   * @type {number}
   */
  _createClass(OrangeSVG, [{
    key: "w",
    get: function get() {
      if (this._width === 0) {
        throw new Error('SVG width should be defined');
      }
      return this._width;
    }

    /**
     * Width
     *
     * @type {number}
     */,
    set: function set(value) {
      this._width = value;
    }

    /**
     * Height
     *
     * @type {number}
     */
  }, {
    key: "h",
    get: function get() {
      if (this._height === 0) {
        throw new Error('SVG height should be defined');
      }
      return this._height;
    }

    /**
     * Height
     *
     * @type {number}
     */,
    set: function set(value) {
      this._height = value;
    }

    /**
     * X coordinate of top left corner
     *
     * @type {number}
     */
  }, {
    key: "x1",
    get:
    /**
     * X coordinate of top left corner
     *
     * @type {number}
     */
    function get() {
      return this._x1;
    }

    /**
     * Y coordinate of top left corner
     *
     * @type {number}
     */,
    set: function set(value) {
      this._x1 = value;
    }
  }, {
    key: "y1",
    get:
    /**
     * Y coordinate of top left corner
     *
     * @type {number}
     */
    function get() {
      return this._y1;
    }

    /**
     * Adds element into SVG document
     *
     * @param {OrangeSVGAbstractElement} element SVG Element
     * @param {object} callbacks Javascript callbacks for the element (works only for DOM)
     * @param {?object} callback_data Data for callback
     * @return {OrangeSVG}
     */,
    set: function set(value) {
      this._y1 = value;
    }
  }, {
    key: "appendChild",
    value: function appendChild(element) {
      var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback_data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this._children.push({
        element: element,
        callbacks: callbacks,
        callback_data: callback_data
      });
      return this;
    }

    /**
     * Renders SVG in the container
     *
     * @param {HTMLElement|string} container
     * @return {SVGSVGElement}
     */
  }, {
    key: "render",
    value: function render(container) {
      var container_element;
      if (typeof container === 'string') {
        container_element = document.getElementById(container);
        if (!container) {
          throw new Error("Element \"".concat(container, "\" not found"));
        }
      } else {
        container_element = container;
      }
      var element = this.element;
      container_element.appendChild(element);
      return element;
    }

    /**
     * SVG Object converted to SVGSVGElement
     *
     * @type {SVGSVGElement}
     */
  }, {
    key: "element",
    get: function get() {
      var svg = document.createElementNS(this.constructor._NS, 'svg');
      svg.setAttribute('xmlns', this.constructor._NS);
      svg.setAttribute('viewBox', this._viewBox);
      svg.setAttribute('width', this.w.toString());
      svg.setAttribute('height', this.h.toString());
      var _iterator = _createForOfIteratorHelper(this._children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;
          svg.appendChild(c.element.createDOMElement(svg.namespaceURI, c.callbacks, c.callback_data));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return svg;
    }

    /**
     * SVG Object converted to HTML string
     *
     * @return {string}
     */
  }, {
    key: "toString",
    value: function toString() {
      return "<svg xmlns=\"".concat(this.constructor._NS, "\" viewBox=\"").concat(this._viewBox, "\" width=\"").concat(this.w, "\" height=\"").concat(this.h, "\">\n\t").concat(this._children.map(function (c) {
        return c.element;
      }).join('\n\t'), "\n</svg>");
    }

    /**
     * SVG namespace
     *
     * @type {string}
     * @static
     * @private
     */
  }, {
    key: "_viewBox",
    get:
    /**
     * SVG "viewBox" argument
     *
     * @type {string}
     * @private
     */
    function get() {
      return "".concat(this.x1, " ").concat(this.y1, " ").concat(this.w, " ").concat(this.h);
    }
  }], [{
    key: "_NS",
    get: function get() {
      return 'http://www.w3.org/2000/svg';
    }
  }]);
  return OrangeSVG;
}();
module.exports = OrangeSVG;